import type { CityConfig } from "../city-template/types";

export const statesvilleConfig: CityConfig = {
  city: "Statesville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "statesville",
  route: "/statesville",
  title: "Emergency Passport Statesville, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Statesville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Iredell County and the Yadkin Valley. Get your passport fast with Fast Passport Center.",
  h1: "Emergency & Expedited Passport Services in Statesville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Statesville and Iredell County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Statesville%20North%20Carolina%20historic%20downtown%20courthouse%20square%20at%20golden%20hour%20with%20majestic%20Iredell%20County%20courthouse%20building%2C%20charming%20tree-lined%20main%20street%20with%20vintage%20storefronts%2C%20American%20small%20town%20Southern%20atmosphere%2C%20green%20rolling%20hills%20of%20Yadkin%20Valley%20in%20background%2C%20warm%20sunset%20light%20with%20clean%20sky%2C%20professional%20architectural%20photography%20with%20warm%20earthy%20tones%20and%20historic%20community%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=statesville-hero-nc-001&orientation=landscape",
  heroImageAlt: "Statesville North Carolina historic downtown courthouse square with Iredell County courthouse at golden hour",
  geoPosition: "35.7827;-80.8873",
  geoPlacename: "Statesville, North Carolina",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 200 miles from Statesville via I-77",
  },
  nearbyCitiesZips: [
    { name: "Statesville", zips: "28625, 28677, 28687" },
    { name: "Mooresville", zips: "28115, 28117" },
    { name: "Troutman", zips: "28166" },
    { name: "Mocksville", zips: "27028" },
    { name: "Salisbury", zips: "28144, 28145, 28146, 28147" },
    { name: "Kannapolis", zips: "28081, 28082, 28083" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Hickory", zips: "28601, 28602, 28603" },
    { name: "Newton", zips: "28658" },
    { name: "Conover", zips: "28613" },
    { name: "Lenoir", zips: "28633, 28645" },
    { name: "Morganton", zips: "28655" },
    { name: "Wilkesboro", zips: "28697" },
    { name: "North Wilkesboro", zips: "28659" },
    { name: "Taylorsville", zips: "28681" },
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Greensboro", zips: "27401–27499" },
    { name: "High Point", zips: "27260, 27261, 27262, 27263, 27265" },
    { name: "Shelby", zips: "28150, 28151, 28152" },
    { name: "Lincolnton", zips: "28092, 28093" },
    { name: "Denver", zips: "28037" },
    { name: "Lake Norman", zips: "28031, 28036, 28117" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Cornelius", zips: "28031" },
    { name: "Huntersville", zips: "28070, 28078" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Iredell County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Iredell County Hub", desc: "Serving Statesville, Mooresville, Troutman, and the Yadkin Valley" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/charlotte" },
    { name: "Fast passport renewal in Mooresville, NC", route: "/mooresville" },
    { name: "Emergency passport help in Salisbury, NC", route: "/salisbury" },
    { name: "Urgent passport services in Kannapolis, NC", route: "/kannapolis" },
    { name: "Same-day passport help in Concord, NC", route: "/concord-nc" },
    { name: "Passport courier services in Hickory, NC", route: "/hickory" },
    { name: "Fast passport renewal in Winston-Salem, NC", route: "/winston-salem" },
    { name: "Passport courier services in Greensboro, NC", route: "/greensboro" },
    { name: "Passport courier services in Huntersville, NC", route: "/huntersville" },
    { name: "Passport courier services in Davidson, NC", route: "/davidson" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Statesville remotely via secure courier. We do not have a walk-in office in Statesville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Iredell County and the Yadkin Valley travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Iredell County and the Yadkin Valley region",
  serviceAreaIntro: "From the historic courthouse square of downtown Statesville to the suburban neighborhoods of Mooresville, from the quiet communities of Troutman and Mocksville to the bustling corridors of Hickory and Conover, from the mountain foothills of Morganton and Lenoir to the Piedmont cities of Winston-Salem and Greensboro — Fast Passport Center serves the entire Statesville region. We regularly help travelers from the Yadkin Valley, Catawba County, and the northern Charlotte metro area get their expedited passports fast.",
  nearbyCitiesIntro: "We serve all Statesville neighborhoods and the surrounding Iredell County and Yadkin Valley area including Mooresville, Troutman, Mocksville, Salisbury, Kannapolis, Concord, Charlotte, Hickory, Newton, Conover, Lenoir, Morganton, Wilkesboro, North Wilkesboro, Taylorsville, Winston-Salem, Greensboro, High Point, Shelby, Lincolnton, Denver, Lake Norman, Davidson, Cornelius, and Huntersville. If you are anywhere in Iredell County, Catawba County, or the Yadkin Valley region, we have you covered for fast passport and expedited passport services.",
  howItWorksIntro: "Most Statesville travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Statesville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays in getting an expedited passport.",
  testimonialsIntro: "Statesville and Iredell County travelers trust us when their departure is days away. Here is what some of them have to say about our emergency passport and fast passport services.",
  faqIntro: "Have questions about expedited passports in Statesville? Here are the most common ones we hear from Iredell County and Yadkin Valley travelers about emergency passport and fast passport processing.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Statesville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rebecca M.",
      location: "Statesville, NC",
      rating: 5,
      text: "My passport expired the week before a family trip to Cancun. Fast Passport Center had my renewal ready in 32 hours. I never left Statesville. The expedited passport service was exceptional.",
      service: "Passport Renewal",
    },
    {
      name: "James T.",
      location: "Mooresville, NC",
      rating: 5,
      text: "Emergency passport for a business trip to Toronto. Got it in 27 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Their fast passport service is the real deal.",
      service: "Emergency Passport",
    },
    {
      name: "Karen L.",
      location: "Troutman, NC",
      rating: 5,
      text: "First passport for my 12-year-old before our summer trip to Europe. Fast Passport Center walked us through every step and had her passport in 5 days. So easy for Iredell County families.",
      service: "Child Passport",
    },
    {
      name: "David W.",
      location: "Mocksville, NC",
      rating: 5,
      text: "Lost my passport 3 days before a cruise to the Caribbean. Fast Passport Center had a replacement in my hands in 30 hours. Their expedited passport service across the Yadkin Valley is unmatched.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "statesville-1",
      name: "Statesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W Front St",
      city: "Statesville",
      state: "NC",
      zip: "28677",
      phone: "(704) 873-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Statesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Statesville facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "statesville-2",
      name: "Mooresville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 E Plaza Dr",
      city: "Mooresville",
      state: "NC",
      zip: "28115",
      phone: "(704) 663-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles south of Statesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Iredell County and Lake Norman area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "statesville-3",
      name: "Troutman Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "317 S Main St",
      city: "Troutman",
      state: "NC",
      zip: "28166",
      phone: "(704) 528-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles south of Statesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Troutman and southern Iredell County. Less crowded. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "statesville-4",
      name: "Mocksville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "171 S Clement St",
      city: "Mocksville",
      state: "NC",
      zip: "27028",
      phone: "(336) 751-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Statesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Davie County and western Iredell County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "statesville-5",
      name: "Iredell County Register of Deeds",
      type: "County Clerk Passport Acceptance",
      address: "221 E Water St",
      city: "Statesville",
      state: "NC",
      zip: "28677",
      phone: "(704) 878-3000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Statesville",
      website: "https://www.iredellcountync.gov/",
      websiteLabel: "Iredell County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "statesville-6",
      name: "Salisbury Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "620 W Innes St",
      city: "Salisbury",
      state: "NC",
      zip: "28144",
      phone: "(704) 636-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Statesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Rowan County and eastern Iredell County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Statesville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Iredell County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Statesville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Iredell County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Statesville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Statesville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Statesville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Statesville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Statesville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5 hour drive to Atlanta." },
    { q: "How fast can I get an expedited passport in Statesville?", a: "Fast Passport Center offers expedited passport services in Statesville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day standard expedited option provides the best value. Both options include full document review and a dedicated agent to ensure your fast passport is processed correctly." },
    { q: "What is the closest passport agency to Statesville?", a: "The nearest regional passport agency to Statesville is the Atlanta Passport Agency, approximately 200 miles away via I-77. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Statesville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Statesville?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 3.5 hours from Statesville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Iredell County and Yadkin Valley residents." },
    { q: "Do you serve the entire Iredell County area for expedited passports?", a: "Absolutely. Fast Passport Center provides expedited passport services throughout the entire Iredell County and Yadkin Valley region including Statesville, Mooresville, Troutman, Mocksville, Salisbury, Kannapolis, Concord, Charlotte, Hickory, Newton, Conover, Lenoir, Morganton, Wilkesboro, North Wilkesboro, Taylorsville, Winston-Salem, Greensboro, High Point, Shelby, Lincolnton, Denver, Lake Norman, Davidson, Cornelius, and Huntersville. Our courier service works seamlessly from any address in Iredell County, Catawba County, and surrounding areas." },
    { q: "Can I expedite a child passport in Statesville?", a: "Yes. Fast Passport Center expedites child passports in Statesville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Iredell County families through the entire fast passport process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Statesville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency for an expedited passport?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change. This is how we deliver fast passport and expedited passport services to Statesville without the long drive." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Statesville", address: "132 Turnersburg Hwy, Statesville, NC 28625", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Statesville", address: "1505 E Broad St, Statesville, NC 28677", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Statesville", address: "142 Turnersburg Hwy, Statesville, NC 28625", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Mooresville", address: "569 River Hwy, Mooresville, NC 28117", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Salisbury", address: "1121 E Broad St, Salisbury, NC 28144", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Hickory", address: "2460 Springs Rd NE, Hickory, NC 28601", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Mocksville", address: "1201 Yadkinville Rd, Mocksville, NC 27028", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Winston-Salem", address: "200 W 2nd St, Winston-Salem, NC 27101", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Statesville",
      address: "1055 Glenway Dr, Statesville, NC 28625",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Mooresville",
      address: "118 Four Seasons Town Centre, Mooresville, NC 28117",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Hickory",
      address: "1845 12th Ave NE, Hickory, NC 28601",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Catawba County and Hickory area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Salisbury",
      address: "1415 W Innes St, Salisbury, NC 28144",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Rowan County and eastern Iredell area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "70 miles south of Statesville",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international airport for the Charlotte metro area. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations. About 75 minutes from Statesville via I-77.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "70 miles east of Statesville",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for Piedmont Triad travelers. Additional domestic routes. About 75 minutes from Statesville.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "160 miles east of Statesville",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Iredell County Register of Deeds", url: "https://www.iredellcountync.gov/142/Register-of-Deeds", description: "Birth, death, and marriage records for Iredell County" },
    { name: "Iredell County Superior Court", url: "https://www.nccourts.gov/locations/iredell-county", description: "Divorce records and court documents for Iredell County" },
  ],
  landmarks: [
    {
      name: "Charlotte Douglas International Airport (CLT)",
      icon: "ri-flight-takeoff-line",
      distance: "~70 miles south of Statesville",
      desc: "Major international hub serving 50M+ passengers annually with nonstop flights to Europe, Mexico, the Caribbean, and 180+ domestic destinations. About 75 minutes from downtown Statesville via I-77 — the closest international airport for Iredell County travelers.",
      url: "https://www.cltairport.com/",
      schemaType: "Airport",
    },
    {
      name: "Historic Downtown Statesville & Iredell County Courthouse",
      icon: "ri-building-2-line",
      distance: "Central Statesville — Center St & Broad St",
      desc: "A classic Piedmont courthouse square district anchored by the 1899 Iredell County Courthouse. Features tree-lined streets, brick storefronts, and one of North Carolina's most intact historic downtowns. Home to boutique shops, craft breweries, and the annual Carolina BalloonFest drawing 30,000+ visitors.",
      url: "https://www.downtownstatesville.com/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Fort Dobbs State Historic Site",
      icon: "ri-flag-line",
      distance: "Statesville — 438 Fort Dobbs Rd",
      desc: "The only North Carolina state historic site associated with the French and Indian War (1754–1763). Features a full-scale reconstructed 1756 frontier fort and visitor center. Represents North Carolina's colonial frontier defense history — a unique archaeological and educational destination.",
      url: "https://historicsites.nc.gov/all-sites/fort-dobbs",
      schemaType: "TouristAttraction",
    },
    {
      name: "Love Valley — Western-Themed Town",
      icon: "ri-compass-line",
      distance: "~20 miles north of Statesville — Brushy Mountains",
      desc: "A purpose-built Old West town founded in 1954 complete with wooden boardwalks, hitching posts, and a rodeo arena. Hosts trail rides, cowboy festivals, and equestrian events throughout the year. A one-of-a-kind tourist attraction in the NC Piedmont that draws visitors from across the Southeast.",
      url: "https://www.lovevalley.com/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Signal Hill Mall & Retail District",
      icon: "ri-store-2-line",
      distance: "East Statesville — 1685 E Broad St",
      desc: "The primary retail hub for Iredell County anchored by Belk, JCPenney, and 60+ retailers. Serves as a regional shopping destination for Statesville, Troutman, Mocksville, and surrounding communities. Generates significant visitor traffic along the I-77 corridor.",
      url: "https://www.shopsignalhill.com/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Mac Anderson Park & Lake",
      icon: "ri-leaf-line",
      distance: "North Statesville — 1733 Mac Anderson Park Rd",
      desc: "A 124-acre park centered around a scenic 35-acre lake offering fishing, paddle boating, walking trails, and picnic shelters. One of Iredell County's most popular outdoor recreation destinations, hosting community events and family gatherings year-round.",
      url: "https://www.statesvillenc.net/parks",
      schemaType: "TouristAttraction",
    },
    {
      name: "Mitchell Community College",
      icon: "ri-school-line",
      distance: "Statesville — 500 W Broad St",
      desc: "Founded in 1852 as Concord Presbyterian Female College, now a comprehensive community college serving 10,000+ students across two campuses. The historic main campus features century-old buildings and anchors downtown Statesville's educational landscape.",
      url: "https://www.mitchellcc.edu/",
      schemaType: "TouristAttraction",
    },
    {
      name: "I-77 / I-40 / US-21 Transportation Corridor",
      icon: "ri-road-map-line",
      distance: "Major transportation corridors through the Statesville metro",
      desc: "I-77 connects Statesville to Charlotte (south) and the Virginia border (north). I-40 runs east to Winston-Salem/Greensboro and west to Hickory/Asheville. US-21 is the historic north-south route. Statesville sits at the strategic I-77/I-40 interchange — one of North Carolina's most important highway intersections, making it a key logistics hub for the Piedmont.",
      url: "https://www.ncdot.gov/",
      schemaType: "CivicStructure",
    },
  ],
  areaServedList: [
    { "@type": "City", name: "Statesville" },
    { "@type": "City", name: "Mooresville" },
    { "@type": "City", name: "Troutman" },
    { "@type": "City", name: "Mocksville" },
    { "@type": "City", name: "Salisbury" },
    { "@type": "City", name: "Hickory" },
    { "@type": "City", name: "Newton" },
    { "@type": "City", name: "Conover" },
    { "@type": "City", name: "Wilkesboro" },
    { "@type": "City", name: "North Wilkesboro" },
    { "@type": "AdministrativeArea", name: "Iredell County" },
    { "@type": "AdministrativeArea", name: "Catawba County" },
    { "@type": "AdministrativeArea", name: "Davie County" },
  ],
  serviceAreaDesc: "Fast Passport Center serves Statesville via secure registered courier — emergency and expedited passport services as fast as 24 hours for Statesville, Mooresville, Troutman, and all Iredell County and Yadkin Valley communities. A+ BBB rated.",
};